import { useEffect, useContext } from 'react';

import { useMediaListener, BREAKPOINTS } from '@xingternal/util';
import { LOGIN_STATE, XingFrameContext } from '@xingternal/xing-frame-provider';
import { useLoginState } from '@xingternal/hops';
import * as Types from '@xingternal/pages-graphql-types';

import { EditContext } from '@xingternal/pages-common';

const useUpdateEditContext = (
  data?: Types.Maybe<Types.EntityPageResult>
): boolean => {
  const loginState = useLoginState();
  const { featureSwitches } = useContext(XingFrameContext);
  const { isEditing, setIsEditing, setIsEditor, setIsAdmin } =
    useContext(EditContext);
  const canEditMobile = featureSwitches?.includes('ep_mobileEdit');
  const isLoggedIn = loginState === LOGIN_STATE.loggedIn;
  const breakpoint = isLoggedIn ? useMediaListener() : null;

  useEffect(() => {
    if (data?.__typename !== 'EntityPage') {
      return;
    }

    const userPageContext = data.userPageContext;
    const canEdit =
      (userPageContext && userPageContext.permissions?.canEdit) || false;
    const canAdmin =
      (userPageContext && userPageContext.permissions?.canAdmin) || false;

    setIsEditor(canEdit);

    if (
      breakpoint !== BREAKPOINTS.desktop &&
      breakpoint !== BREAKPOINTS.nav &&
      !canEditMobile
    ) {
      setIsEditing(false);
    } else if (typeof isEditing === 'undefined') {
      setIsEditing(canEdit);
    }

    setIsAdmin(canAdmin);
  }, [data, breakpoint]);

  if (!data) {
    return false;
  }

  return typeof isEditing !== 'undefined';
};

export default useUpdateEditContext;
